export const calcuateRequestType = 'CALCULATE_REQUEST';
export const calcuateRequestSucessType = 'CALCULATE_REQUEST_SUCCESS';
export const calcuateRequestFailureType = 'CALCULATE_REQUEST_FAILURE';
export const calcuateValidationFailureType = 'CALCULATE_VALIDATION_FAILURE';
export const calcuateRequestCompleteType = 'CALCULATE_REQUEST_COMPLETE';

export const createPdfRequestType = 'CREATE_PDF_REQUEST';
export const createPdfSuccessType = 'CREATE_PDF_REQUEST_SUCCESS';
export const createPdfFailureType = 'CREATE_PDF_REQUEST_FAILURE';